import React, {createContext, useContext} from 'react';
import {useParams} from 'react-router';

import {propagateErrorsContext} from '../../util/errors';
import {
  EntityRunsQueryResult,
  useEntityRunsQuery,
} from './../../generated/graphql';

export const EntityRunsContext = createContext<EntityRunsQueryResult | null>(
  null
);

type EntityRunsProviderProps = {
  children: React.ReactNode;
};
export const EntityRunsContextProvider = ({
  children,
}: EntityRunsProviderProps) => {
  const {entityName} = useParams<{entityName: string}>();

  const result = useEntityRunsQuery({
    variables: {entityName},
    context: propagateErrorsContext(),
  });

  return (
    <EntityRunsContext.Provider value={result}>
      {children}
    </EntityRunsContext.Provider>
  );
};

export const useEntityRuns = () => {
  const entityRunData = useContext(EntityRunsContext);

  if (entityRunData == null) {
    throw new Error(
      'useEntityRuns must be used within an EntityRunsContextProvider'
    );
  }

  return entityRunData;
};
